import TransparentButton from './transparent-button/TransparentButton';
import React from 'react';

export const EditButton = ({ onClick, hideText }) => (
    <TransparentButton onClick={onClick}>
        <i className={'material-icons'}>edit</i>
        {!hideText && <span>Edit</span>}
    </TransparentButton>
);
